import React from 'react'
import PublicSiderXS from '../../Layouts/Sider/PublicSiderXS'
import TabletConfirmedAppointment from './TabletConfirmedAppointment'

export default function TabletAppointmentPage ({ box, appointment, onCancel, appointmentStatus }) {
  return (
    <>
      <PublicSiderXS />
      <TabletConfirmedAppointment box={box} appointment={appointment} onCancel={onCancel} appointmentStatus={appointmentStatus} />
    </>
  )
}
